import {Component, Inject, Input} from '@angular/core';
import {Config} from '../../../models/config';
import {IsUsedPlayerConfigurationDefinitionAction} from '../../../actions/player-configuration-definition';
import {Store} from '@ngrx/store';
import * as fromShared from '../../../reducers';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-input-options',
  templateUrl: './input-options.component.html',
  styleUrls: ['./input-options.component.scss']
})
export class InputOptionsComponent  {
  @Input() config: Config;
  constructor( @Inject(L10N_LOCALE) public locale: L10nLocale, private store: Store<fromShared.AppState>) {
  }
  remove(): void {

    this.config.options.hideAll = 'hide';
    // TODO: deplacer dans un service si re utiliser
    this.store.dispatch(new IsUsedPlayerConfigurationDefinitionAction({name: this.config.controlName[0], value: false}));
  }
}
